import { omit } from 'lodash';
import { ICreateSavedFilter, ISavedFilter } from '../../components/sidebar-filters/saved-filter/interface';
import { API } from '../api';

export const fetchSavedFilters = async ({ subType }: { subType: string }, signal?: AbortSignal | null): Promise<ISavedFilter[]> => {
    const params = new URLSearchParams({
        subType,
    }).toString();

    const path = `/filters?${params}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load saved filters!`);
};

export const createSavedFilter = async (filter: ICreateSavedFilter, signal?: AbortSignal | null): Promise<void> => {
    const path = '/filters';

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(omit(filter, 'id')),
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot create saved filter!`);
};

export const updateSavedFilter = async (filter: ICreateSavedFilter, signal?: AbortSignal | null): Promise<void> => {
    const path = `/filters/${filter.id}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(omit(filter, 'id')),
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot update saved filter!`);
};

export const deleteSavedFilter = async (filterId: number, signal?: AbortSignal | null): Promise<void> => {
    const path = `/filters/${filterId}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.ok) {
        return;
    }

    const respBody: any = await response.json();
    throw new Error(respBody?.error?.message || `Cannot delete saved filter!`);
};
